import styles from "./RemoteSelect.module.scss";
import {Button} from "antd";
import React from "react";

interface RemoteSelectAllButtonProps {
    onSelectAll: () => void
}

const RemoteSelectAllButton = ({onSelectAll}: RemoteSelectAllButtonProps) => {
    return <>
        <Button
            data-testid='remote-select-all-button'
            className={styles.selectAllButton}
            onClick={onSelectAll}>Select All
        </Button>
    </>
}

export default RemoteSelectAllButton